module.exports = __webpack_public_path__ + "assets/images/anonymous.6de44e6eb9dc32187635b13868e6b2fc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anonymous.gif
// module id = 7
// module chunks = 0